import DashboardLayout from '../../../shared/DashboardLayout';

const General = () => {
  return (
    <DashboardLayout>
      
    </DashboardLayout>
  )
}

export default General
